import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';

import { LoadingPage } from '../loading/loading';
import { EditInfoPage } from '../edit-info/edit-info';
import { ConsultationPage } from '../consultation/consultation';
import { DispensaryPage } from '../dispensary/dispensary';
import { VerificationPage } from '../verification/verification';

import { DataProvider } from '../../providers/data/data';
import { ConstantsProvider } from '../../providers/constants/constants';
import { CloudDataProvider } from '../../providers/cloud-data/cloud-data';
import { ConsultationDataProvider } from '../../providers/consultation-data/consultation-data';
import { ConsultationDataParserProvider } from '../../providers/consultation-data-parser/consultation-data-parser';

@Component({
   selector: 'page-history-disp',
   templateUrl: 'history-disp.html'
})

export class HistoryPageDisp {

   // data from server
   private consultations = [];
   private consObjs = [];
   private dispObjs = [];
   private tickets = [];
   private active = [];

   /** ----- Constructor ----- **/

   constructor(private data: DataProvider,
      private constants: ConstantsProvider,
      private cloudData: CloudDataProvider,
      private consultationData: ConsultationDataProvider,
      private consultationParser: ConsultationDataParserProvider,
      private navCtrl: NavController,
      private modalCtrl: ModalController,
      private alertCtrl: AlertController) { }


   /** ----- View LifeCycle ----- **/

   ionViewWillEnter() {
      // show loading indicator and try to get consultation(s) of current viewing patient
      let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
      loading.present();
      this.getConsultations().then(res => {

         // dismiss loading indicator when request complete
         loading.dismiss();
      });
   }

   /** ----- Internal Methods ----- **/

   getConsultations = () => {

      return new Promise(resolve => {

         // pack params and send to server
         let params = {
            'token': this.data.token,
            'pat_row_id': this.constants.selectedPatient['id']
         };
         this.cloudData.getConsultations(params).then(res => {

            // handle response
            if (res['status'] == true) {
               // save result
               this.consultations = res['result']['consultations'];
               this.tickets = res['result']['tickets'];
               this.constants.selectedMedicals = res['result']['medical_records'];
               this.constants.physicians = res['result']['physicians'];

               // reset consultationItems and dispensaryItems in the list
               this.consObjs = [];
               this.dispObjs = [];
               for (let i = 0; i < this.consultations.length; i++) {
                  let symptoms = JSON.parse(this.consultations[i]['con_symptoms']);
                  if (symptoms != null) {
                     let dataObj = JSON.parse(symptoms['data']);
                     let remarkObj = JSON.parse(symptoms['remark']);
                     let dispObj = JSON.parse(this.consultations[i]['con_dispensary']);
                     symptoms['data'] = dataObj;
                     symptoms['remark'] = remarkObj;
                     this.consObjs.push(symptoms);
                     this.dispObjs.push(dispObj);
                  }
                  else {
                     this.consObjs.push([]);
                     this.dispObjs.push([]);
                  }
               }

               // reset active state
               this.active = [];
               for (let i = 0; i < this.consultations.length; i++) {
                  this.active.push(false);
               }
               resolve(true);
            }
            else {
               resolve(false);
            }
         });
      });
   }


   upsertTicketActive = () => {

      return new Promise(resolve => {

         let params = {
            'token': this.data.token,
            'from_queue': this.data.selectedTicket['tkt_queue'],
            'from_order': ' ' + this.data.selectedTicket['tkt_order'],
            'to_queue': this.data.selectedTicket['tkt_queue'],
            'isPhy': true
         };
         this.cloudData.upsertTicketActive(params).then(res => {

            // dismiss loading indicator
            resolve(res);
         });
      });
   }


   /** ----- UI Callbacks ----- **/

   onBackClicked() {

      // if currently under consultation
      if (this.consultationData.editActive == true) {
         let backConfirm = this.alertCtrl.create({
            title: '返回主頁',
            subTitle: '已輸入的資料將不會被儲存，確認要返回主頁嗎？',
            buttons: [
               {
                  text: '取消',
                  role: 'cancel'
               },
               {
                  text: '確認',
                  handler: () => {

                     // mark edit currently inactive
                     this.consultationData.editActive = false;

                     // if navigation stacks more than 3 views
                     if (this.navCtrl.getViews().length > 3) {
                        // remove all unnecessary page(s) before pop
                        this.navCtrl.remove(2, this.navCtrl.getViews().length - 3).then(res => {

                           this.navCtrl.pop();
                        });
                     }
                     else {
                        this.navCtrl.pop();
                     }
                  }
               }
            ],
            enableBackdropDismiss: false
         });
         backConfirm.present();
      }
      else {
         // if navigation stacks more than 3 views
         if (this.navCtrl.getViews().length > 3) {
            // remove all unnecessary page(s) before pop
            this.navCtrl.remove(2, this.navCtrl.getViews().length - 3).then(res => {

               this.navCtrl.pop();
            });
         }
         else {
            this.navCtrl.pop();
         }
      }

   }


   onNavBtnClicked(inIdx) {

      // if clicked '進行診症'
      if (inIdx == 1) {
         // find name to be displayed
         let nameStr = this.constants.selectedPatient['pat_lastname_zh'] + this.constants.selectedPatient['pat_firstname_zh'];
         if (nameStr.length <= 0 || nameStr == '') nameStr = this.constants.selectedPatient['pat_lastname_en'] + ' ' + this.constants.selectedPatient['pat_firstname_en'];
         if (nameStr.length <= 0 || nameStr == '') nameStr = '';
         let alert = this.alertCtrl.create({
            title: '開始診症',
            subTitle: '確認要開始為 ' + nameStr + ' 診症嗎？',
            buttons: [
               {
                  text: '返回',
                  role: 'cancel'
               },
               {
                  text: '確認',
                  handler: () => {

                     // show loading indicator and update ticket status
                     let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
                     loading.present();
                     this.upsertTicketActive().then(res => {

                        // dismiss loading indicator and handle response
                        loading.dismiss();
                        if (res['status'] == true) {
                           // get consultation obj just been active
                           this.consultationData.consultation = res['result']['consultations'];
                           this.goToConsultation();
                        }
                        else {
                           // show error alert
                           let alert = this.alertCtrl.create({
                              title: '上傳失敗',
                              subTitle: '請稍後再嘗試',
                              buttons: [
                                 {
                                    text: '確認',
                                    role: 'cancel'
                                 }
                              ],
                              enableBackdropDismiss: false
                           });
                           alert.present();
                        }
                     });
                  }
               }
            ],
            enableBackdropDismiss: false
         });
         alert.present();
      }

   }


   goToConsultation() {
      // push to Consultation/Dispensary/Verification and remove this page
      // this.constants.switchTab(1);
      this.navCtrl.push(this.data.currentStep == 0 ? ConsultationPage : this.data.currentStep == 1 ? DispensaryPage : VerificationPage, {}, { animate: false });
      this.navCtrl.remove(this.navCtrl.getViews().length - 1, 1);
   }


   onInfoEditClicked() {

      this.navCtrl.push(EditInfoPage);

   }


   onItemClicked(inIdx) {

      this.active[inIdx] = !this.active[inIdx];

   }


   onPrintClicked(inIdx) {

      let printConfirm = this.alertCtrl.create({
         title: '列印',
         subTitle: '確認要列印配藥標籤嗎？',
         buttons: [
            {
               text: '中文'
            },
            {
               text: 'English'
            },
            {
               text: '取消',
               role: 'cancel'
            }
         ],
         enableBackdropDismiss: false
      });
      printConfirm.present();

   }


   onItemEditClicked(inIdx) {

      // only allow 'DONE' or 'DISPENSING' ticket for admin accounts
      if (
         // this.constants.isAdmin &&
         !(this.consultations[inIdx]['tkt_id']['tkt_status'] == 'done' || this.consultations[inIdx]['tkt_id']['tkt_status'] == 'dispensing')) {
         // show alert for permission declined
         let error = this.alertCtrl.create({
            title: '存取拒絕',
            subTitle: '您的帳號沒有此權限',
            buttons: [
               {
                  text: '確認',
                  role: 'cancel'
               }
            ],
            enableBackdropDismiss: false
         });
         error.present();
         return;
      }

      // prompt for confirmation
      let editConfirm = this.alertCtrl.create({
         title: (this.consultationData.editActive) ? '診症進行中' : '編輯診症藥單紀錄',
         subTitle: (this.consultationData.editActive) ? '確認要放棄進行中的診症嗎？' : '確認要繼續嗎？',
         buttons: [
            {
               text: '取消',
               role: 'cancel'
            },
            {
               text: '確認',
               handler: () => {

                  this.consultationData.clearAll();
                  this.consultationData.editMode = true;
                  this.consultationParser.convertSymptoms(this.consultations[inIdx]);
                  this.consultationParser.convertDispensaries(this.dispObjs[inIdx]);
                  this.navCtrl.push(ConsultationPage);
               }
            }
         ],
         enableBackdropDismiss: false
      });
      editConfirm.present();

   }

}



// WEBPACK FOOTER //
// ./src/pages/history-disp/history-disp.ts